import React from 'react';
import Header from '../../components/header';
import BlogBody from './body';
import Footer from '../../components/footer';

function Blog(props) {
    return (
        <div>
            <Header></Header>
            <BlogBody></BlogBody>
            <Footer></Footer>
        </div>
    );
}

export default Blog;